import React from "react"
import Heading from "@components/heading"
import getValue from "get-value"
import {getImageData} from '@utils/image'
import {GatsbyImage} from 'gatsby-plugin-image'

const Perks = ({ id, perks, title }) => {
  return (
    <div id={id} className="w-full">
      <Heading level="2" className="mb-16 text-center headline">
        {title}
      </Heading>

      <div className="grid max-w-6xl grid-cols-2 gap-8 mx-auto gap-y-6 md:gap-10 md:grid-cols-3">
        {perks.map(perkItem => (
          <Perk key={perkItem._key} {...perkItem} />
        ))}
      </div>
    </div>
  )
}

const Perk = ({ icon, title }) => {
  const imageTitle = getValue(icon, "image.asset.originalFilename").replace(/\.(.*)$/, '').replace(/[^a-zA-Z0-9]+/g, ' ' )
  const imageAssetId = getValue(icon, 'image.asset.id')
  const imageData = getImageData(imageAssetId, {width: 100, height: 100 })

  return (
    <div className="text-center">
      {imageData && (
        <GatsbyImage
          className="w-16 h-auto mx-auto mb-2 md:mb-4 md:w-24"
          image={imageData}
          alt={imageTitle}
          title={title}
          fadeIn={false}
          loading="eager"
        />
      )}
      <Heading level="3" className="leading-normal text-center subheadline">
        {title}
      </Heading>
    </div>
  )
}

export default Perks
